/**
 * Tree project probability distribution constants
 *
 * The probability system uses a range of [0, 10000) for distributing
 * tree projects based on their configured percentages.
 *
 * - TREE_PROJECT_PROBABILITY_MIN: Minimum bound (inclusive) = 0
 * - TREE_PROJECT_PROBABILITY_RANGE_MAX: Maximum bound for calculations (exclusive) = 10001
 *   Used in percentage calculations to generate ranges that cover [0, 10000)
 * - TREE_PROJECT_PROBABILITY_RANDOM_MAX: Maximum random value (inclusive) = 9999
 *   Used when generating random numbers to ensure they fall within [0, 10000)
 *
 * Mathematical relationship:
 * - RANGE_MAX is 10001 (exclusive upper bound means ranges go up to but not including 10001)
 * - RANDOM_MAX is 9999 (inclusive, so lodash random(0, 9999) generates 0-9999)
 * - The -2 accounts for: -1 to get to 10000 (the exclusive boundary), -1 more to get 9999 (the inclusive max)
 *
 * This ensures random values (0-9999 inclusive) always fall within
 * project ranges ([0, 10000) exclusive upper bound).
 */
export const TREE_PROJECT_PROBABILITY_MIN = 0;
export const TREE_PROJECT_PROBABILITY_RANGE_MAX = 10001;
// RANGE_MAX - 1 = 10000 (exclusive to inclusive), - 1 = 9999 (max valid random value)
export const TREE_PROJECT_PROBABILITY_RANDOM_MAX = TREE_PROJECT_PROBABILITY_RANGE_MAX - 2;
